<template>
  <BaseMultiSelectable
    v-model="model"
    :options="props.options"
    :variant="props.variant"
    :readonly="props.readonly"
    class="base-select-tags"
  >
    <template #unselected="{ item }">
      <BaseTag variant="light">
        {{ item.label }}
        <template #append-icon>
          <BaseIcon
            name="vuesax:add-circle-bold"
            size="16px"
            fill-type="solid"
          />
        </template>
      </BaseTag>
    </template>
    <template #selected="{ item }">
      <BaseTag variant="primary">
        {{ item.label }}
        <BaseIcon
          name="vuesax:close-circle-bold"
          size="16px"
          fill-type="solid"
          color="var(--color-foreground-light)"
        />
      </BaseTag>
    </template>
  </BaseMultiSelectable>
</template>

<script setup lang="ts">
import BaseIcon from '../icon/index.vue'
import BaseMultiSelectable from '../multi-selectable/index.vue'
import BaseTag from '../tag/index.vue'

export interface OptionType {
  label: string
  value: string
}

interface Props {
  options: OptionType[]
  variant?: 'secondary' | 'light'
  readonly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'secondary',
})
const model = defineModel<Array<string>>({ required: true })
</script>

<style lang="scss" scoped>
.base-select-tags {
  padding: rem(12px);

  &:deep(.base-tag) {
    box-shadow: 0 0 12px 0 #3333;
  }
}
</style>
